import { render, staticRenderFns } from "./SpadPL.vue?vue&type=template&id=2b53d338"
import script from "./SpadPL.vue?vue&type=script&lang=js"
export * from "./SpadPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports